
import useScrollAnimation from '../../../hooks/useScrollAnimation';

export default function IndustryAlignment() {
  const ref = useScrollAnimation();

  const industries = [
    {
      title: 'Finance',
      description: 'Operational visibility, forecasting intelligence, and structured automation.',
      icon: 'ri-line-chart-line',
      image: 'https://public.readdy.ai/ai/img_res/2186c8c84d9cd4b9830d7a7ca3eabf36.jpg',
    },
    {
      title: 'Medical & Wellness',
      description: 'Reduced administrative burden. Smarter patient and internal workflows.',
      icon: 'ri-heart-pulse-line',
      image: 'https://readdy.ai/api/search-image?query=Clean%20modern%20medical%20clinic%20interior%20with%20white%20walls%20and%20soft%20blue%20accents%20showing%20organized%20workspace%20with%20digital%20tablet%20and%20minimal%20medical%20equipment%20calm%20serene%20healthcare%20environment%20premium%20aesthetic&width=600&height=700&seq=ind002&orientation=portrait',
    },
    {
      title: 'Real Estate',
      description: 'Pipeline clarity, lead intelligence, and predictable growth systems.',
      icon: 'ri-building-line',
      image: 'https://readdy.ai/api/search-image?query=Elegant%20modern%20real%20estate%20office%20with%20large%20windows%20showing%20city%20skyline%20clean%20white%20interior%20with%20subtle%20blue%20accent%20details%20architectural%20models%20on%20desk%20premium%20professional%20calm%20atmosphere%20natural%20light&width=600&height=700&seq=ind003&orientation=portrait',
    },
    {
      title: 'Home Services',
      description: 'Scheduling automation, operational oversight, scalable service systems.',
      icon: 'ri-tools-line',
      image: 'https://readdy.ai/api/search-image?query=Modern%20clean%20home%20services%20dispatch%20center%20with%20organized%20digital%20scheduling%20board%20on%20wall%20white%20and%20blue%20color%20scheme%20professional%20workspace%20with%20tablets%20and%20tools%20neatly%20arranged%20calm%20efficient%20atmosphere&width=600&height=700&seq=ind004&orientation=portrait',
    },
  ];

  return (
    <section ref={ref} id="industries" className="py-28 bg-drift">
      <div className="max-w-7xl mx-auto px-8 lg:px-12">
        <div className="max-w-2xl mb-16">
          <p className="animate-on-scroll text-[13px] font-medium text-anchor tracking-wide uppercase mb-4">Industries</p>
          <h2 className="animate-on-scroll text-4xl md:text-5xl font-light text-navy mb-5 tracking-tight" style={{ transitionDelay: '0.1s' }}>
            Built for Industries That Require Precision
          </h2>
          <p className="animate-on-scroll text-base text-navy/50 font-light leading-relaxed" style={{ transitionDelay: '0.15s' }}>
            We support sectors where clarity, trust, and steady improvement matter most.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {industries.map((industry, index) => (
            <div
              key={index}
              className="animate-on-scroll group relative bg-white rounded-2xl overflow-hidden hover:shadow-xl hover:shadow-navy/6 transition-all duration-500 cursor-pointer"
              style={{ transitionDelay: `${0.1 * index}s` }}
            >
              <div className="h-52 overflow-hidden">
                <img
                  src={industry.image}
                  alt={`${industry.title} - SkySails AI consulting`}
                  title={`${industry.title} AI solutions`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                />
              </div>
              <div className="p-7">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-horizon mb-4">
                  <i className={`${industry.icon} text-lg text-anchor`}></i>
                </div>
                <h3 className="text-lg font-medium text-navy mb-2 tracking-tight">
                  {industry.title}
                </h3>
                <p className="text-sm text-navy/45 leading-relaxed font-light">
                  {industry.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
